import React, { useState } from "react";
import { Button, Group, Image, Modal, Stack, TextInput } from "@mantine/core";
import MediaGrid from "./MediaGrid";

interface Props {
  label?: string;
  description?: string;
  placeholder?: string;
  value: string;
  onChange: (url: string) => void;
}

const MediaPicker: React.FC<Props> = ({ label, description, placeholder, value, onChange }) => {
  const [open, setOpen] = useState(false);

  return (
    <Stack gap={4}>
      <Group align="flex-end" gap="xs" wrap="nowrap">
        <TextInput
          label={label}
          description={description}
          placeholder={placeholder ?? "Wklej URL lub wybierz z biblioteki"}
          value={value}
          onChange={(e) => onChange(e.currentTarget.value)}
          style={{ flex: 1 }}
        />
        <Button variant="light" onClick={() => setOpen(true)}>
          Wybierz...
        </Button>
      </Group>

      {value && (
        <div
          style={{
            marginTop: 4,
            width: 120,
            height: 80,
            border: "1px solid #e9ecef",
            borderRadius: 6,
            padding: 4,
            background: "#fafafa",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
          }}
        >
          <Image src={value} alt="" fit="contain" mah="100%" maw="100%" />
        </div>
      )}

      <Modal opened={open} onClose={() => setOpen(false)} size="xl" title="Biblioteka mediów">
        <MediaGrid
          selectedUrl={value}
          onPick={(url) => {
            onChange(url);
            setOpen(false);
          }}
        />
      </Modal>
    </Stack>
  );
};

export default MediaPicker;
